import { Card, Divider, Space, Typography, Collapse, Button } from "antd";
import { useOutletContext, useParams } from "react-router";
import MessageCard from "../../components/cards/MessageCard";
import AssignResourceDomainSteps from "../../components/settings/AssignResourceDomainSteps";
import { IComponentDetails, IEnvDetails } from "../../types";

const { Text, Link } = Typography;

const ResourceSettingsCustomDomain = () => {
    const { envId } = useParams();
    const { env, component } = useOutletContext<{ env: IEnvDetails, component: IComponentDetails }>();

    return (
        <Space direction="vertical" className="full-width">
            {
                component.domain.eligibleForDomainConfiguration ?
                    <Card>
                        <Card.Meta
                            title="Custom Domain"
                            description={
                                <>
                                    Set up your custom domain to make your application accessible from the Internet. Manage and modify your domain settings here as required.
                                </>
                            }
                        />
                        <Divider />

                        {component.domains && component.domains.length > 0 ? (
                            <Space direction="vertical" size="large" className="full-width">

                                {component.domains.map((domain, index) => (
                                    <Card
                                        key={index}
                                        title={
                                            <Space direction="vertical" size={0}>
                                                <Space>
                                                    <Text strong>Domain {index + 1}</Text>
                                                    {domain.propPrefix && (
                                                        <Text type="secondary">({domain.propPrefix})</Text>
                                                    )}
                                                </Space>
                                                <Link href={domain.accessUrl} target="_blank" rel="noreferrer">
                                                    {domain.accessUrl}
                                                </Link>
                                            </Space>
                                        }
                                        style={{ marginBottom: 16 }}
                                        type="inner"
                                    >
                                        <br />
                                        <AssignResourceDomainSteps
                                            envId={envId!}
                                            resourceName={component.name}
                                            resourceVersion={component.version}
                                            domainCNAME={domain.CNAME!}
                                            isModal={false}
                                            propertyPrefix={domain.propPrefix}
                                            customDomainName={domain.displayAssignDomainBtn ? undefined : domain.accessUrl}
                                            awsAccount={{
                                                id: env.awsAccountId!,
                                                // CloudFront only supports ACM certificates in the N. Virginia Region (us-east-1)
                                                region: domain.CNAME!.endsWith("cloudfront.net") ?
                                                    "us-east-1" :
                                                    env.region!
                                            }}
                                        />
                                    </Card>
                                ))}
                            </Space>
                        ) : (
                            <Text>No domain configurations available.</Text>
                        )}
                    </Card> :
                    <Card>
                        <Card.Meta
                            title="Assign domain"
                            description="Domain configuration is not supported for this type of component"
                        />
                    </Card>
            }
        </Space>
    );
}

export default ResourceSettingsCustomDomain;